import { render, staticRenderFns } from "./SavedModal.vue?vue&type=template&id=82a7b730"
import script from "./SavedModal.vue?vue&type=script&lang=js"
export * from "./SavedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports